export enum ParamSourceEndpointIds {
  Body = 'body',
  Status = 'status',
  Headers = 'headers',
}
